import { render, staticRenderFns } from "./CorrectionsPage.vue?vue&type=template&id=680b2070&lang=pug&"
import script from "./CorrectionsPage.vue?vue&type=script&lang=js&"
export * from "./CorrectionsPage.vue?vue&type=script&lang=js&"
import style0 from "./CorrectionsPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports